module.exports = __webpack_public_path__ + "img/130-00-CMS 4_3.f341612b.png";